import React, { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, onSnapshot, setDoc, runTransaction } from 'firebase/firestore';

// IMPORTANT: Replace these placeholder values with your actual Firebase config, Telegram bot token and Chat ID.
const firebaseConfig = {
  apiKey: "AIzaSyA3t3s86dmDfT0iWyfsj-iwkqbi4p6K52A",
  authDomain: "missyou-1efda.firebaseapp.com",
  projectId: "missyou-1efda",
  storageBucket: "missyou-1efda.firebasestorage.app",
  messagingSenderId: "484454266351",
  appId: "1:484454266351:web:d9016e43428d90b285b21a",
  measurementId: "G-C9DTHP5KNJ"
};

const TELEGRAM_TOKEN = '8217431967:AAG-sU4tmHop29zCe29i1Rz-pLyIimWZGxc';
const CHAT_ID = '7487517468';

// Main App component for the "I Miss You" counter and Telegram bot integration.
const App = () => {

  // Pre-defined messages to be sent to the Telegram bot.
  const MESSAGES = [
    "Your lovely girlfriend is missing you. She missed you for [counter] times!",
    "She's missing you. She missed you for [counter] times!",
    "I miss you soo much babe. She missed you for [counter] times!",
    "Babee i miss you so much. She missed you for [counter] times!",
    "I miss youuuu. She missed you for [counter] times!",
    "I miss you babe. She missed you for [counter] times!",
    "I love you and miss you. She missed you for [counter] times!",
    "I miss you so much you make me cry and feel so lonely. She missed you for [counter] times!",
    "I miss you. She missed you for [counter] times!",
    "I missed you like hundreds of letters ❤️. She missed you for [counter] times!",
    "Babe i miss you. She missed you for [counter] times!",
    "I miss you so badly. She missed you for [counter] times!",
    "I miss you this morning so much. She missed you for [counter] times!",
    "I just miss you. She missed you for [counter] times!",
    "I miss youuuu 😭. She missed you for [counter] times!",
    "I miss you hun, wanna vid call later? She missed you for [counter] times!",
    "I miss your voice. She missed you for [counter] times!",
    "I miss you, babe, I wish you were here. She missed you for [counter] times!",
    "You make me miss you so much and I hate it. She missed you for [counter] times!",
    "I miss you and I don't want to say it. She missed you for [counter] times!",
    "I hate it when I miss you. She missed you for [counter] times!",
    "When I miss you, I remember all your messages and smile. She missed you for [counter] times!",
    "I miss youuuu, ganteng banget pacar aku ❤️❤️. She missed you for [counter] times!",
    "I MISS YOU. She missed you for [counter] times!",
    "I miss you all night. She missed you for [counter] times!",
    "I miss you today. She missed you for [counter] times!",
    "I miss you a lot. She missed you for [counter] times!",
    "I dunno, i just miss you. She missed you for [counter] times!",
  ];

  // State hooks to manage app data and UI state
  const [count, setCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [db, setDb] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isPlaneFlying, setIsPlaneFlying] = useState(false);
  const [animatedMessage, setAnimatedMessage] = useState('');

  // Helper to get local date string YYYY-MM-DD
  const getLocalDateString = () => {
    const d = new Date();
    const offset = d.getTimezoneOffset();
    const localDate = new Date(d.getTime() - (offset * 60 * 1000));
    return localDate.toISOString().split('T')[0];
  };

  // Initialize Firebase and set up the authentication state listener.
  useEffect(() => {
    try {
      const app = initializeApp(firebaseConfig);
      const firestore = getFirestore(app);
      const firebaseAuth = getAuth(app);
      setDb(firestore);

      const unsubscribeAuth = onAuthStateChanged(firebaseAuth, async (user) => {
        if (user) {
          setUserId(user.uid);
          console.log('User signed in with UID:', user.uid);
          setIsLoading(false);
        } else {
          console.log('No user signed in. Attempting to sign in anonymously...');
          try {
            await signInAnonymously(firebaseAuth);
          } catch (error) {
            console.error('Anonymous sign-in failed:', error);
            setMessage('Error: Failed to sign in. Please check your Firebase settings.');
            setIsLoading(false);
          }
        }
      });
      return () => unsubscribeAuth();
    } catch (e) {
      console.error('Failed to initialize Firebase:', e);
      setMessage('Error: Failed to initialize app. Please check your Firebase config.');
      setIsLoading(false);
    }
  }, []);

  // Fetch initial data and set up real-time listener from Firestore.
  useEffect(() => {
    if (!db || !userId) return;

    // Use a single, perpetual document for the counter.
    const counterDocRef = doc(db, `miss_you_app`, 'perpetual-counter');

    const unsubscribe = onSnapshot(counterDocRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        const todayStr = getLocalDateString();
        const permCount = data.count || 0;
        const currentTodayCount = data.lastUpdatedDate === todayStr ? (data.todayCount || 0) : 0;
        
        setCount(permCount);
        setTodayCount(currentTodayCount);
        console.log('Real-time count updated. Permanent:', permCount, 'Today:', currentTodayCount);
      } else {
        console.log('Counter document does not exist. Creating it now...');
        setDoc(counterDocRef, { 
          count: 0,
          todayCount: 0,
          lastUpdatedDate: getLocalDateString()
        }).catch(e => console.error('Error creating document:', e));
      }
    }, (error) => {
      console.error("Error listening to document:", error);
      setMessage('Error: Failed to load data.');
    });

    return () => unsubscribe();
  }, [db, userId]);

  const handleButtonClick = async () => {
    if (isLoading || isAnimating) {
      setMessage('Please wait for the animation to finish.');
      return;
    }

    if (TELEGRAM_TOKEN === 'YOUR_BOT_TOKEN_HERE' || CHAT_ID === 'YOUR_CHAT_ID_HERE') {
      setMessage('Please replace the placeholder token and chat ID in the code first.');
      return;
    }

    const counterDocRef = doc(db, `miss_you_app`, 'perpetual-counter');

    try {
      const todayStr = getLocalDateString();
      const nextPermanentCount = count + 1;
      const nextTodayCount = todayCount + 1;

      // Pick a random message and set it for the animation
      const randomMessageIndex = Math.floor(Math.random() * MESSAGES.length);
      const selectedMessage = MESSAGES[randomMessageIndex];
      const messageText = selectedMessage.replace(
        /She missed you for \[counter\] times!?/,
        `She missed you for ${nextTodayCount} times today and she missed you since 21 Feb 2025 for ${nextPermanentCount} times`
      );
      setAnimatedMessage(messageText);

      // Start the animation
      setIsAnimating(true);
      setIsPlaneFlying(false);

      // Await database transaction update
      await runTransaction(db, async (transaction) => {
        const sfDoc = await transaction.get(counterDocRef);
        if (!sfDoc.exists()) {
          transaction.set(counterDocRef, {
            count: 1,
            todayCount: 1,
            lastUpdatedDate: todayStr
          });
          return;
        }

        const data = sfDoc.data();
        const currentCount = data.count || 0;
        let currentTodayCount = data.todayCount || 0;

        if (data.lastUpdatedDate !== todayStr) {
          currentTodayCount = 0;
        }

        transaction.update(counterDocRef, {
          count: currentCount + 1,
          todayCount: currentTodayCount + 1,
          lastUpdatedDate: todayStr
        });
      });
      console.log('Count incremented in Firestore.');

      // Wait a moment for the envelope to open, then start the plane animation
      setTimeout(() => {
        setIsPlaneFlying(true);
        sendTelegramMessage(messageText);
      }, 1200); // Delay for opening animation

      // Reset all states after a delay to allow the plane animation to complete
      setTimeout(() => {
        setIsAnimating(false);
        setIsPlaneFlying(false);
        setAnimatedMessage(''); // Reset text to hide it from the envelope
        setMessage('I have told your boyfriend that you are missing him. 💕');
      }, 4000); // Total duration of the animation cycle
    } catch (e) {
      console.error('Error updating document:', e);
      setMessage('Error: Failed to update count.');
      setIsAnimating(false);
      setIsPlaneFlying(false);
    }
  };

  const sendTelegramMessage = async (text) => {
    try {
      const apiEndpoint = `https://api.telegram.org/bot${TELEGRAM_TOKEN}/sendMessage`;
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          chat_id: CHAT_ID,
          text: text,
          parse_mode: 'Markdown'
        })
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.description || 'Failed to send Telegram message.');
      }
      console.log('Telegram message sent successfully:', result);
    } catch (e) {
      console.error('Error sending Telegram message:', e);
      setMessage('Error sending Telegram message. Check your token and chat ID.');
    }
  };

  // Hearts animation effect - Fixed to prevent scrolling
  useEffect(() => {
    const createHeart = () => {
      const heart = document.createElement('div');
      heart.className = 'heart';
      heart.style.left = `${Math.random() * 100}vw`;
      heart.style.animationDuration = `${4 + Math.random() * 2}s`;
      heart.style.position = 'fixed'; // Changed to fixed positioning
      heart.style.pointerEvents = 'none'; // Ensure no interaction
      heart.style.zIndex = '-1'; // Put behind content
      document.body.appendChild(heart);

      setTimeout(() => {
        if (heart.parentNode) {
          heart.remove();
        }
      }, 6000);
    };

    const interval = setInterval(createHeart, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="app-container">
        <div className="card">
          <h1 className="title">Miss Me?!</h1>
          <p className="subtitle">Each time you miss me, hit the button and I'll know your heart is calling.</p>
          
          <div className="button-container">
              <div className={`envelope-container ${isPlaneFlying ? 'fly-away' : ''}`} onClick={handleButtonClick}>
              {/* Outer text that fades on click */}
              <div className={`outside-text ${isAnimating ? 'fade-out' : ''}`}>I Miss You</div>

              {/* The envelope and inner letter */}
              <div className={`animated-mail ${isAnimating ? 'sent' : ''}`}>
                <div className="back-fold"></div>
                <div className="letter">
                  <div className="letter-border"></div>
                  <div className="letter-context">{animatedMessage}</div>
                  <div className="letter-stamp">
                    <div className="letter-stamp-inner"></div>
                  </div>
                </div>
                <div className="top-fold"></div>
                <div className="body"></div>
                <div className="left-fold"></div>
              </div>

              {/* The paper plane, shown when isPlaneFlying is true */}
              <div className={`paper-plane ${isPlaneFlying ? 'show fly-away-plane' : ''}`}></div>
              <div className="shadow"></div>
            </div>
            <div className="counters-container">
              <div className="counter-item">
                <div className="counter-value">{isLoading ? '...' : todayCount}</div>
                <p className="counter-label">Moments Today</p>
              </div>
              <div className="counter-divider"></div>
              <div className="counter-item">
                <div className="counter-value">{isLoading ? '...' : count}</div>
                <p className="counter-label">Since 21 Feb 2025</p>
              </div>
            </div>
          </div>
          
          {message && (
            <div className="message-box">
              {message}
            </div>
          )}
        </div>
      </div>
      
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Pacifico&family=Poppins:wght@400;600;700;800&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        html, body {
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
        }
        
        body {
          font-family: 'Poppins', sans-serif;
          background: radial-gradient(circle at center, #1a0033, #0d001a, #000000);
          color: #e5e7eb;
          min-height: 100vh;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
        
        .app-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1rem;
          position: relative;
          box-sizing: border-box;
        }
        
        .card {
          position: relative;
          width: 100%;
          max-width: min(85vw, 380px);
          min-width: 300px;
          padding: 1.25rem;
          background: linear-gradient(145deg, #1a1a2e, #16213e);
          border: 2px solid #ff00ff;
          border-radius: 1.25rem;
          box-shadow:
            0 25px 50px -12px rgba(255, 0, 255, 0.3),
            0 0 60px rgba(0, 255, 255, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: visible;
        }
        
        @media (min-width: 640px) {
          .card {
            max-width: min(75vw, 420px);
            padding: 1.5rem;
          }
        }
        
        @media (min-width: 768px) {
          .card {
            max-width: min(70vw, 460px);
            padding: 1.75rem;
          }
        }
        
        @media (min-width: 1024px) {
          .card {
            max-width: min(65vw, 500px);
            padding: 2rem;
          }
        }

        /* Blood drop animation */
        .card::before {
          content: '';
          position: absolute;
          top: -5px;
          left: 50%;
          width: 12px;
          height: 12px;
          background: linear-gradient(45deg, #ff0080, #d11a2a);
          border-radius: 50%;
          transform: translateX(-50%);
          animation: blood-drip 4s linear infinite;
          animation-delay: 1s;
          box-shadow: 0 0 10px #ff0080;
        }
        
        @keyframes blood-drip {
          0% { 
            top: -5px; 
            opacity: 1; 
            transform: scale(1) translateX(-50%); 
            box-shadow: 0 0 10px #ff0080;
          }
          10% { 
            transform: scale(1.3) translateX(-50%); 
            box-shadow: 0 0 15px #ff0080;
          }
          20% { 
            top: 80px; 
            opacity: 1; 
            transform: scale(1) translateX(-50%); 
          }
          30% { 
            transform: scale(1.1) translateX(-50%); 
          }
          50% { 
            top: 200px; 
            opacity: 1; 
            transform: scale(1.4) translateX(-50%); 
            box-shadow: 0 0 20px #ff0080;
          }
          70% { 
            top: 350px; 
            opacity: 1; 
            transform: scale(1) translateX(-50%); 
          }
          85% { 
            top: 450px; 
            opacity: 0.8; 
            transform: scale(1.2) translateX(-50%); 
          }
          100% { 
            top: 600px; 
            opacity: 0; 
            transform: scale(0.5) translateX(-50%); 
          }
        }
        
        .title {
          font-size: clamp(1.5rem, 5vw, 2rem);
          font-weight: 800;
          background: linear-gradient(45deg, #ff00ff, #00ffff, #ff0080);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 0.75rem;
          text-shadow: 0 0 30px rgba(255, 0, 255, 0.5);
          animation: glow-pulse 2s ease-in-out infinite alternate;
          line-height: 1.2;
        }

        @keyframes glow-pulse {
          from { filter: drop-shadow(0 0 10px #ff00ff); }
          to { filter: drop-shadow(0 0 25px #ff00ff); }
        }
        
        .subtitle {
          font-size: clamp(0.875rem, 3.5vw, 1.1rem);
          font-weight: 400;
          color: #c9c9c9;
          margin-bottom: 1.5rem;
          text-shadow: 0 0 10px rgba(0, 255, 255, 0.3);
          line-height: 1.5;
          max-width: 90%;
        }
        
        .button-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1.25rem;
          width: 100%;
        }
        
        .counters-container {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 100%;
          margin-top: 0.5rem;
          gap: 0.5rem;
        }

        .counter-item {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .counter-value {
          font-size: clamp(1.75rem, 6vw, 2.5rem);
          font-weight: 800;
          background: linear-gradient(45deg, #00ffff, #ff00ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          text-shadow: 0 0 30px rgba(0, 255, 255, 0.4);
          animation: counter-glow 3s ease-in-out infinite alternate;
          line-height: 1.1;
        }

        @keyframes counter-glow {
          from { filter: drop-shadow(0 0 10px #00ffff); }
          to { filter: drop-shadow(0 0 20px #00ffff); }
        }

        .counter-divider {
          width: 2px;
          height: 40px;
          background: linear-gradient(to bottom, transparent, #ff00ff, transparent);
        }

        .counter-label {
          font-size: clamp(0.6rem, 2.2vw, 0.8rem);
          font-weight: 500;
          color: #a3a3a3;
          text-shadow: 0 0 5px rgba(255, 255, 255, 0.2);
          line-height: 1.3;
          margin-top: 0.25rem;
          text-align: center;
        }
        
        .message-box {
          margin-top: 1.25rem;
          padding: 1rem;
          background: linear-gradient(145deg, #2a2a4e, #1e1e3e);
          border: 1px solid #ff00ff;
          border-radius: 1rem;
          color: #e5e7eb;
          font-size: clamp(0.8rem, 3vw, 1rem);
          font-weight: 400;
          line-height: 1.5;
          box-shadow: 0 0 20px rgba(255, 0, 255, 0.2);
          text-align: center;
          max-width: 100%;
        }

        /* Heart animation CSS - Fixed positioning */
        .heart {
          position: fixed;
          bottom: -50px;
          width: 16px;
          height: 16px;
          background: linear-gradient(45deg, #ff00ff, #ff0080);
          transform: rotate(45deg);
          animation: float 6s linear infinite;
          pointer-events: none;
          z-index: -1;
          box-shadow: 0 0 10px rgba(255, 0, 255, 0.8);
        }

        .heart::before,
        .heart::after {
          content: "";
          position: absolute;
          width: 16px;
          height: 16px;
          background: linear-gradient(45deg, #ff00ff, #ff0080);
          border-radius: 50%;
          box-shadow: 0 0 8px rgba(255, 0, 255, 0.6);
        }

        .heart::before {
          top: -8px;
          left: 0;
        }

        .heart::after {
          left: -8px;
          top: 0;
        }
        
        /* Envelope and Plane Animation CSS */
        .envelope-container {
          position: relative;
          width: clamp(160px, 40vw, 200px);
          height: clamp(140px, 35vw, 175px);
          margin: 0.75rem auto;
          cursor: pointer;
          z-index: 10;
          transition: all 0.6s ease;
          touch-action: manipulation;
        }

        .envelope-container:hover {
          transform: scale(1.05);
          filter: drop-shadow(0 0 20px rgba(255, 0, 255, 0.4));
        }

        .envelope-container.fly-away {
          animation: container-fly-away 2s ease-in-out forwards;
        }

        @keyframes container-fly-away {
          0% {
            transform: scale(1.05) translateY(0);
            opacity: 1;
          }
          100% {
            transform: scale(0.3) translateY(-800px);
            opacity: 0;
          }
        }

        .outside-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-8deg);
          font-family: 'Pacifico', cursive;
          font-size: clamp(1rem, 4vw, 1.5rem);
          font-weight: 400;
          background: linear-gradient(45deg, #ff00ff, #00ffff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          z-index: 11;
          text-shadow: 0 0 15px rgba(255, 0, 255, 0.8);
          pointer-events: none;
          transition: all 0.8s ease-out;
          animation: text-glow 2s ease-in-out infinite alternate;
          white-space: nowrap;
        }

        @keyframes text-glow {
          from { filter: drop-shadow(0 0 5px #ff00ff); }
          to { filter: drop-shadow(0 0 15px #ff00ff); }
        }

        .outside-text.fade-out {
          opacity: 0;
          transform: translate(-50%, -50%) rotate(-8deg) scale(1.5);
        }

        .animated-mail {
          position: absolute;
          height: clamp(120px, 30vw, 150px);
          width: clamp(160px, 40vw, 200px);
          transition: all 0.8s ease;
          transform: translateY(0);
          top: clamp(10px, 3vw, 15px);
          left: 0;
        }

        .animated-mail.sent {
          opacity: 0;
          transform: scale(0.8) rotate(5deg);
          pointer-events: none;
        }
        
        .animated-mail .body {
          position: absolute;
          bottom: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 0 clamp(80px, 20vw, 100px) clamp(160px, 40vw, 200px);
          border-color: transparent transparent #e74c3c transparent;
          z-index: 2;
          box-shadow: 0 0 15px rgba(231, 76, 60, 0.4);
        }
        
        .animated-mail .top-fold {
          position: absolute;
          top: clamp(40px, 10vw, 50px);
          width: 0;
          height: 0;
          border-style: solid;
          border-width: clamp(40px, 10vw, 50px) clamp(80px, 20vw, 100px) 0 clamp(80px, 20vw, 100px);
          transform-origin: 50% 0%;
          transition: all 0.8s ease;
          border-color: #c0392b transparent transparent transparent;
          z-index: 2;
          box-shadow: 0 0 10px rgba(192, 57, 43, 0.4);
        }
        
        .animated-mail.sent .top-fold {
          transform: rotateX(180deg);
          z-index: 0;
        }
        
        .animated-mail .back-fold {
          position: absolute;
          bottom: 0;
          width: clamp(160px, 40vw, 200px);
          height: clamp(80px, 20vw, 100px);
          background: linear-gradient(145deg, #c0392b, #a93226);
          z-index: 0;
          box-shadow: 0 0 15px rgba(192, 57, 43, 0.3);
        }
        
        .animated-mail .left-fold {
          position: absolute;
          bottom: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: clamp(40px, 10vw, 50px) 0 clamp(40px, 10vw, 50px) clamp(80px, 20vw, 100px);
          border-color: transparent transparent transparent #e74c3c;
          z-index: 2;
        }
        
        .animated-mail .letter {
          left: clamp(16px, 5vw, 20px);
          bottom: 0px;
          position: absolute;
          width: clamp(128px, 32vw, 160px);
          height: clamp(48px, 12vw, 60px);
          background: linear-gradient(145deg, #ffffff, #f8f9fa);
          z-index: 1;
          overflow: hidden;
          transition: all 0.8s ease;
          color: #2c3e50;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          border-radius: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        }
        
        .animated-mail .letter-border {
          position: absolute;
          top: 0;
          height: 8px;
          width: 100%;
          background: repeating-linear-gradient(
            -45deg,
            #e74c3c,
            #e74c3c 6px,
            transparent 6px,
            transparent 14px
          );
        }
        
        .animated-mail .letter-context {
          font-family: 'Pacifico', cursive;
          font-size: clamp(0.5rem, 2vw, 0.7rem);
          font-weight: 400;
          padding: clamp(4px, 2vw, 8px) clamp(3px, 1vw, 5px);
          color: #2c3e50;
          white-space: normal;
          word-wrap: break-word;
          transition: all 0.6s ease-in-out;
          opacity: 0;
          transform: scale(0.8);
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .animated-mail.sent .letter-context {
          opacity: 1;
          transform: scale(1);
        }

        .animated-mail .letter-stamp {
          position: absolute;
          top: 5px;
          right: 8px;
          border-radius: 50%;
          height: 20px;
          width: 20px;
          background: linear-gradient(45deg, #e74c3c, #c0392b);
          opacity: 0.7;
          box-shadow: 0 0 5px rgba(231, 76, 60, 0.5);
        }

        /* Paper Plane CSS */
        .paper-plane {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0) rotate(0deg);
          width: clamp(60px, 15vw, 80px);
          height: clamp(60px, 15vw, 80px);
          opacity: 0;
          transition: all 0.6s ease;
          z-index: 9;
        }
        
        .paper-plane.show {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1) rotate(0deg);
        }

        .paper-plane.fly-away-plane {
          animation: fly-away-plane 2s ease-in-out forwards;
        }

        @keyframes fly-away-plane {
          0% {
            transform: translate(-50%, -50%) scale(1) rotate(0deg);
            opacity: 1;
          }
          50% {
            transform: translate(-50%, -50%) scale(1.2) rotate(15deg);
            opacity: 1;
          }
          100% {
            transform: translate(-200px, -800px) scale(0.3) rotate(45deg);
            opacity: 0;
          }
        }
        
        .paper-plane::before,
        .paper-plane::after {
          content: '';
          position: absolute;
          border-style: solid;
        }
        
        .paper-plane::before {
          top: 0;
          left: 0;
          border-width: 0 clamp(30px, 8vw, 40px) clamp(30px, 8vw, 40px) clamp(30px, 8vw, 40px);
          border-color: transparent transparent #00ffff transparent;
          box-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
        }
        
        .paper-plane::after {
          bottom: 0;
          left: 0;
          border-width: clamp(30px, 8vw, 40px) clamp(30px, 8vw, 40px) 0 clamp(30px, 8vw, 40px);
          border-color: #ff00ff transparent transparent transparent;
          box-shadow: 0 0 15px rgba(255, 0, 255, 0.6);
        }

        /* Shadow */
        .shadow {
          position: absolute;
          top: clamp(180px, 45vw, 220px);
          left: 50%;
          width: clamp(250px, 60vw, 300px);
          height: clamp(15px, 4vw, 20px);
          transition: all 0.6s ease;
          transform: translateX(-50%);
          border-radius: 100%;
          background: radial-gradient(rgba(255, 0, 255, 0.3), rgba(0, 255, 255, 0.1), transparent);
        }
        
        /* Mobile optimizations */
        @media (max-width: 480px) {
          .app-container {
            padding: 0.75rem;
          }
          
          .card {
            padding: 1.25rem;
            border-radius: 1.25rem;
            max-width: 95vw;
          }
          
          .button-container {
            gap: 1.25rem;
          }
          
          .envelope-container {
            margin: 0.75rem auto;
          }
          
          .message-box {
            margin-top: 1.25rem;
            padding: 0.875rem;
          }
        }
        
        /* Tablet optimizations */
        @media (min-width: 768px) and (max-width: 1024px) {
          .envelope-container:hover {
            transform: scale(1.1);
          }
        }
        
             /* Desktop optimizations - removed the overly large settings */
        @media (min-width: 1024px) {
          .button-container {
            gap: 2rem;
          }
          
          .envelope-container:hover {
            transform: scale(1.08);
          }
        }
        
        @keyframes float {
          0% {
            transform: translateY(0) rotate(45deg);
            opacity: 1;
          }
          100% {
            transform: translateY(-100vh) rotate(45deg);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
};

export default App;